import { Component, Input, OnInit } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { User } from 'src/app/models/user';
import { IdentitySignatureService } from 'src/app/services/identitySignature.service';
import { LoggingService } from 'src/app/services/logging.service';
import { ToastService } from 'src/app/services/toast.service';

@Component({
  selector: 'app-user-signature',
  templateUrl: './user-signature.component.html'
})
export class UserSignatureComponent implements OnInit {

  @Input() userGuid!: string;

  public signatureProviders: any;
  errorMessage!: string;
  defaultError: boolean = true;
  invalidInput: boolean = false;
  user: User = new User;
  securityMethods: any;
  signatureProviderClaim: string = "Advanced";
  cloudProvider: any;

  constructor(
    private signatureService: IdentitySignatureService,
    private loggingService: LoggingService,
    private toastService: ToastService) {
  }


  ngOnInit(): void {
    this.getSignMethod(this.userGuid);
  }

  private getSignMethod(forUserGuid: string) {
    this.signatureService.getSigningMethod(forUserGuid)
      .then(value => {
        lastValueFrom(value)
          .then((data: any) => {
            this.signatureProviders = data.cloudProviders;
            this.signatureProviderClaim = data.signatureProviderClaims;
            if (data.cloudProvider !== null) {
              this.cloudProvider = data.cloudProviders.find((s: any) => s.code === data.cloudProvider);
            }
          })
          .catch(error => {
            this.loggingService.logException(error);
          });
      })
      .catch(error => {
        this.loggingService.logException(error);
      });
  }

  changeSignMethod(method: string) {
    this.signatureProviderClaim = method;
    if (this.signatureProviderClaim === "CscSignatureProvider") this.cloudProvider = this.signatureProviders[0];
    else this.cloudProvider = null;
  }

  changeCloudProvider(provider: string) {
    this.cloudProvider = this.signatureProviders.find((s: any) => s.code === provider);
  }

  async saveSignatureMethod() {
    let signatureMethod = {

      SignatureProviderClaims: this.signatureProviderClaim,
      CloudProvider: this.cloudProvider?.code
    };
    let updateSigningMethodReturn = await this.signatureService.updateSigningMethod(this.userGuid, signatureMethod);
    await lastValueFrom(updateSigningMethodReturn);
    this.toastService.showSaved();
  }

}